import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function RollerSkatingIcon(props: IconProps) {
    return <Icon {...props} iconKey={"roller_skating"}/>
}
